<script>
export default {
  name: "GccAutoUpdate",
  computed: {
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    componentName() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCComponent;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    placementViewOrder() {
      return this.$store.getters["ugc/tempData/getPlacementViewOrder"];
    },
    placement() {
      // if quarters is active component and is on first placement view
      if (
        this.pdm.components[this.componentName].ugc.placements[0].gcc_values[
          this.screenSize
        ].gcc_autorotate &&
        this.placementViewOrder === 0
      ) {
        return 1;
      } else {
        return 0;
      }
    },
    screenSize() {
      return this.$store.getters["utils/returnScreenSize"];
    }
  },
  created() {
    this.$eventBus.$on("image-set", this.init);
  },
  beforeDestroy() {
    this.$eventBus.$off("image-set", this.init);
  },
  methods: {
    init() {
      if (this.$store.getters["utils/isGCC"]) {
        this.$store.commit("ugc/tempData/REMOVE_ALMOST_DONE_VIEW");
        // if the current component is a quarters component
        if (
          this.pdm.components[this.componentName].ugc.placements[0].gcc_values[
            this.screenSize
          ].gcc_autorotate
        ) {
          this.quartersShiftUp();
          this.shiftLeft();
        } else {
          this.vampShiftUp();
          this.shiftLeft();
        }
        this.autoZoom();
        this.autoRotate();
        this.$eventBus.$emit("gcc-autoupdate-finish");
      }
    },
    autoZoom() {
      const img = this.fabricCanvas.getObjects()[0];
      const autoZoomValue = this.pdm.components[this.componentName].ugc
        .placements[this.placement].gcc_values[this.screenSize].gcc_autozoom;
      img.set("scaleX", autoZoomValue);
      img.set("scaleY", autoZoomValue);
      this.fabricCanvas.requestRenderAll();
    },
    vampShiftUp() {
      const img = this.fabricCanvas.getObjects()[0];
      const shiftUpValue = this.pdm.components[this.componentName].ugc.placements[
        this.placement
      ].gcc_values[this.screenSize].gcc_shift_up;
      img.set("top", shiftUpValue);
      this.fabricCanvas.requestRenderAll();
    },
    quartersShiftUp() {
      const img = this.fabricCanvas.getObjects()[0];
      const shiftUpValue = this.pdm.components[this.componentName].ugc.placements[
        this.placement
      ].gcc_values[this.screenSize].gcc_shift_up;
      img.set("top", shiftUpValue);
      this.fabricCanvas.requestRenderAll();
    },
    shiftLeft() {
      const img = this.fabricCanvas.getObjects()[0];
      const shiftLeftValue = this.pdm.components[this.componentName].ugc
        .placements[this.placement].gcc_values[this.screenSize].gcc_shift_left;
      img.set("left", shiftLeftValue);
      this.fabricCanvas.requestRenderAll();
    },
    autoRotate() {
      const img = this.fabricCanvas.getObjects()[0];
      const autoRotateAngle = this.pdm.components[this.componentName].ugc
        .placements[this.placement].gcc_values[this.screenSize].gcc_autorotate;
      img.set("angle", autoRotateAngle);
      this.fabricCanvas.requestRenderAll();
    }
  },
  render() {
    return null;
  }
};
</script>
